import { useEffect, useRef, RefObject } from 'react';
import { TelegramAuthData } from '../types';

declare global {
  interface Window {
    onTelegramWidgetAuth?: (data: TelegramAuthData) => void;
  }
}

const useTelegramLoginWidget = (
  containerRef: RefObject<HTMLDivElement>,
  onAuth: (data: TelegramAuthData) => void,
  botId: string | undefined
) => {
  const callbackRef = useRef(onAuth);
  callbackRef.current = onAuth;

  useEffect(() => {
    if (!botId || !containerRef.current) return;

    window.onTelegramWidgetAuth = (data: TelegramAuthData) => {
      if (data.error) {
        console.error('Telegram auth error:', data.error);
        return;
      }
      callbackRef.current(data);
    };

    const hiddenWrapper = document.createElement('div');
    hiddenWrapper.style.position = 'absolute';
    hiddenWrapper.style.width = '0';
    hiddenWrapper.style.height = '0';
    hiddenWrapper.style.overflow = 'hidden';

    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'tg-auth-button';
    hiddenWrapper.appendChild(button);

    const script = document.createElement('script');
    script.src = 'https://oauth.telegram.org/js/telegram-login.js?3';
    script.async = true;
    script.setAttribute('data-client-id', botId);
    script.setAttribute('data-onauth', 'onTelegramWidgetAuth(data)');
    script.setAttribute('data-request-access', 'write phone');
    hiddenWrapper.appendChild(script);

    containerRef.current.appendChild(hiddenWrapper);

    const container = containerRef.current;

    return () => {
      delete window.onTelegramWidgetAuth;
      if (hiddenWrapper.parentNode === container) {
        container.removeChild(hiddenWrapper);
      }
    };
  }, [botId, containerRef]);

  const triggerAuth = () => {
    const tgButton =
      containerRef.current?.querySelector<HTMLButtonElement>('.tg-auth-button');
    if (tgButton) {
      tgButton.click();
    }
  };

  return { triggerAuth };
};

export default useTelegramLoginWidget;
